import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import './QuickDateRangeSelector.css';

const DATE_RANGES = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  THIS_WEEK: 'this_week',
  MTD: 'mtd',
  CUSTOM: 'custom',
};

const QuickDateRangeSelector = ({ value, onChange }) => {
  const handleChange = (event, newValue) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <div className="quick-date-range-selector">
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={handleChange}
        aria-label="date range selector"
        className="quick-date-toggle-group"
      >
        <ToggleButton value={DATE_RANGES.TODAY} aria-label="today">
          Today
        </ToggleButton>
        <ToggleButton value={DATE_RANGES.YESTERDAY} aria-label="yesterday">
          Yesterday
        </ToggleButton>
        <ToggleButton value={DATE_RANGES.THIS_WEEK} aria-label="this week">
          This Week
        </ToggleButton>
        <ToggleButton value={DATE_RANGES.MTD} aria-label="month to date">
          MTD
        </ToggleButton>
        <ToggleButton value={DATE_RANGES.CUSTOM} aria-label="custom range">
          Custom
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};

export default QuickDateRangeSelector;
export { DATE_RANGES };
